var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { aapi } from '@ovh-ux/manager-core-api';
import { isTopLevelApplication, } from '@ovh-ux/manager-config';
import { getHeaders } from '@ovh-ux/request-tagger';
import ShellClient from './shell-client.js';
import StandaloneShellClient from './standalone-shell-client.js';
import IFrameMessageBus from '../message-bus/iframe.js';
function fetchApplications() {
    return __awaiter(this, void 0, void 0, function* () {
        return aapi
            .get('/applications', {
            headers: Object.assign({ 'Content-Type': 'application/json;charset=utf-8', Accept: 'application/json' }, getHeaders('/engine/2api/applications')),
        })
            .then(({ data }) => data);
    });
}
export const buildURLIfStandalone = (appConfig) => {
    var _a;
    const queryParams = Object.fromEntries(new URLSearchParams(window.location.search).entries());
    if (((_a = appConfig === null || appConfig === void 0 ? void 0 : appConfig.container) === null || _a === void 0 ? void 0 : _a.enabled) === true) {
        if (!queryParams.hasOwnProperty('standalone')) {
            const targetURL = new URL(appConfig.publicURL);
            const currentHash = window.location.hash;
            if (currentHash) {
                targetURL.hash = `${(targetURL.hash || '#').replace(/\/$/, '')}/${currentHash.replace(/^#?\/?/, '')}`;
            }
            if (window.location.hostname !== 'localhost') {
                return targetURL.href;
            }
        }
    }
    return window.location.href;
};
export function initIFrameClientApi(appId) {
    const client = new ShellClient();
    const clientApi = client.getApi();
    client.setApplicationId(appId);
    client.setMessageBus(new IFrameMessageBus());
    clientApi.routing.listenForHashChange();
    return Promise.resolve(clientApi);
}
export function initStandaloneClientApi(appId, applications) {
    return __awaiter(this, void 0, void 0, function* () {
        let appConfig = applications[appId];
        if (!appConfig) {
            if (window.location.hostname === 'localhost') {
                appConfig = {
                    container: {
                        containerURL: '',
                        enabled: false,
                        isDefault: false,
                        path: '',
                    },
                    publicURL: window.location.href,
                    universe: 'hub',
                    url: window.location.href,
                };
            }
            else {
                throw new Error(`Unknown application '${appId}'`);
            }
        }
        const url = buildURLIfStandalone(appConfig);
        if (window.location.href !== url) {
            window.location.href = url;
        }
        const client = new StandaloneShellClient();
        client.setApplicationId(appId);
        return client.init().then(() => client.getApi());
    });
}
export default function init(applicationId) {
    return __awaiter(this, void 0, void 0, function* () {
        let initPromise;
        if (isTopLevelApplication()) {
            initPromise = fetchApplications().then((apps) => {
                return initStandaloneClientApi(applicationId, apps);
            });
        }
        else {
            initPromise = initIFrameClientApi(applicationId);
        }
        return initPromise.then((shellApi) => __awaiter(this, void 0, void 0, function* () {
            shellApi.ux.resetAccountSidebar();
            return shellApi.environment
                .setApplication(applicationId)
                .then(() => shellApi);
        }));
    });
}
//# sourceMappingURL=index.js.map